import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import GrayButton from 'components/buttons/GrayButton';
import WhiteButton from 'components/buttons/WhiteButton';
import { H4 } from 'components/typography/Headers';
import { Text1 } from 'components/typography/Texts';

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 24px;
`;

const Header = styled(H4)`
  margin-bottom: 16px;
`;

const Description = styled(Text1)`
  font-size: 16px;
  line-height: 24px;
  margin: 0;
`;

interface Props {
  onHasAccount: () => void;
  onNoAccount: () => void;
}

const AccountCheckPopup = ({ onHasAccount, onNoAccount }: Props) => {
  const { t } = useTranslation('checkout');

  return (
    <Container data-testid={'account-prompt-popup'}>
      <Header data-testid={'header'}>{t('account-check.header')}</Header>
      <Description data-testid={'description'}>{t('account-check.description')}</Description>
      <ButtonsContainer>
        <WhiteButton data-testid={'has-account-button'} onClick={onHasAccount}>
          {t('account-check.has-account-button')}
        </WhiteButton>
        <GrayButton data-testid={'no-account-button'} onClick={onNoAccount}>
          {t('account-check.no-account-button')}
        </GrayButton>
      </ButtonsContainer>
    </Container>
  );
};

export default AccountCheckPopup;
